import Skeleton from 'react-loading-skeleton';

import Card from '~/shared/components/Card';
import Typography from '~/shared/components/Typography';
import KPIIcon from '~/shared/assets/icons/kpi.svg';

export default function AverageUtilizationCard({
  size,
  loading,
}: {
  size: string;
  loading: boolean;
}) {
  return (
    <Card className="flex flex-col gap-[18px]  ">
      <div className="flex items-center gap-[9px]">
        <KPIIcon className="size-8" />
        <div className="flex flex-col gap[3px]">
          <Typography fontWeight={500} variant="p3" color="text-primary-900">
            Average utilization
          </Typography>
          <Typography variant="caption" color="text-gray-700">
            Of monitored volumes, over the last 24 hours
          </Typography>
        </div>
      </div>
      {loading ? (
        <Skeleton
          containerClassName="h-[30px] block"
          className="h-[30px]  rounded-[8px]"
          baseColor="var(--color-gray-200)"
          highlightColor="#FFFF"
          width={145}
        />
      ) : (
        <Typography
          fontWeight={500}
          variant="H1-med"
          color="text-[#2D2D32]"
          className="font-family-outfit"
        >
          {size}
        </Typography>
      )}
    </Card>
  );
}
